import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why you can't focus on a single great idea",
  "published": "2012-10-09T00:00:00.000Z",
  "redirect_from": ["/blog/why-you-cant-focus-on-a-single-great-idea/swizec/5395"],
  "categories": "Uncategorized",
  "author": "Swizec Teller",
  "hero": "./img/blog-wp-content-uploads-2012-10-many-doors.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/10/many-doors.jpg",
        "alt": "Many doors",
        "title": "Many doors"
      }}></img>{`](./img/blog-wp-content-uploads-2012-10-many-doors.jpg)`}</p>
    <p>{`Last night I was reading Jeff Atwoods' `}<a parentName="p" {...{
        "href": "http://www.amazon.com/gp/product/B008HUMTO0/ref=as_li_qf_sp_asin_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B008HUMTO0&linkCode=as2&tag=ageewitahat-20%22"
      }}>{`Effective Programming: More Than Writing Code`}</a></p>
    <p>{`In the chapter about marketing weasels abusing people's innate biases he talks about a concept that strikes very close to home - Aversion to Loss.`}</p>
    <p>{`Turns out, humans would rather spin around in circles keeping all options open, than say NO! to opportunities that are clearly useless. I think this perfectly explains why I keep working on a bunch of good ideas and can't seem to focus on a single great idea.`}</p>
    <p>{`So far, this realization has not helped me fix the problem.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Ariely and Shin conducted an experiment on MIT students. They devised a computer game which offered players three doors: Red, Blue, and Green. You started with 100 clicks. You clicked to enter a room. Once in a room, each click netted you between 1-10 cents. You could also switch rooms (at the cost of a click). The rooms were programmed to provide different levels of rewards (there was variation within each room's payoffs, but it was pretty easy to tell which one provided the best payout). Players tended to try all three rooms, figure out which one had the highest payout, and then spend all their time there. (These are MIT students we're talking about). Then, however, Ariely introduced a new wrinkle: Any door left unvisited for 12 clicks would disappear forever. With each click, the unclicked doors shrank by 1/12th. Now, players jumped from door to door, trying to keep their options open.They made 15% less money; in fact, by choosing any of the doors and sticking with it, they could have made more money. Ariely increased the cost of opening a door to 3 cents; no change--players still seemed compelled to keeping their options open. Ariely told participants the exact monetary payoff of each door; no change. Ariely allowed participants as many practice runs as they wanted before the actual experiment; no change. Ariely changed the rules so that any door could be "reincarnated" with a single click; no change. Players just couldn't tolerate the idea of the loss, and so they did whatever was necessary to prevent their doors from closing, even though disappearance had no real consequences and could be easily reversed. We feel compelled to preserve options, even at great expense, even when it doesn't make sense.`}</p>
    </blockquote>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.prweb.com/releases/collaboration/dna/prweb9976886.htm"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/117317474_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.prweb.com/releases/collaboration/dna/prweb9976886.htm"
        }}>{`KMWorld 2012 Brings Focus to Learning Networks and the Flow of Ideas; a New Book on Collaboration Sets the Stage`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://wordsmithintheworks.wordpress.com/2012/10/09/the-six-lessons-ari-emmanuel-lives-by/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_2_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://wordsmithintheworks.wordpress.com/2012/10/09/the-six-lessons-ari-emmanuel-lives-by/"
        }}>{`the six lessons ari emmanuel lives by`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.trendhunter.com/keynote/selfcontrol-keynote"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/115059845_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.trendhunter.com/keynote/selfcontrol-keynote"
        }}>{`How to Bypass Temptation - Dan Ariely's Self-Control Keynote Offers Tips to Fight Off Desires (TrendHunter.com)`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.economist.com/blogs/democracyinamerica/2012/08/inequality"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/106685680_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.economist.com/blogs/democracyinamerica/2012/08/inequality"
        }}>{`How much equality would you like?`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=180fce21-acb8-4323-910b-d082b7b4df07",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      